module.exports = __webpack_public_path__ + "img/donante-otra-ronda.7c001642.jpeg";